import { render, staticRenderFns } from "./KidsEvents.vue?vue&type=template&id=1fcb2a68&scoped=true&"
import script from "./KidsEvents.vue?vue&type=script&lang=js&"
export * from "./KidsEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcb2a68",
  null
  
)

export default component.exports